import React from 'react';
import { InfoIcon } from 'lucide-react';
import { IndependentTooltip } from 'src/components/Tooltip/IndependentTooltip';

export const GamstopPreviouslyPositiveLimitsConfigurationTooltip = (): JSX.Element => (
    <IndependentTooltip
        position='bottom'
        underline={false}
        content={
            <div className='text-left max-w-sm'>
                <p className='mb-2'>
                    Automated updates can only maintain or decrease limits - increases are strictly blocked.
                </p>
                <p>
                    During an automated process, the Active Limit and Max Limit are evaluated independently against
                    their current values. Proposed values that are lower than or equal to the current limits will be
                    applied successfully. Any proposed value higher than the existing limit for that field will be
                    automatically rejected to ensure compliance guardrails are maintained.
                </p>
            </div>
        }
    >
        <InfoIcon
            className='size-4 text-muted-foreground cursor-pointer'
            data-test='gamstop-pp-limits-configuration-info-icon'
        />
    </IndependentTooltip>
);
